(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iconic-advance-faq-fourth"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initSection(container) {
    var section = container.querySelector && container.querySelector('.iconic-advance-faq-fourth-section')
      ? container
      : container.nodeType === 1 && container.classList && container.classList.contains('iconic-advance-faq-fourth-section')
        ? container
        : null;
    if (!section) section = container;

    var previewImg = section.querySelector ? section.querySelector('[id^="iconic-advance-faq-fourth-preview-"]') : null;
    var placeholders = section.querySelectorAll ? section.querySelectorAll('.iconic-advance-faq-fourth-placeholder-svg') : [];
    var triggers = section.querySelectorAll ? section.querySelectorAll('.iconic-advance-faq-fourth-accordion .iconic-accordion-content') : [];

    if (!triggers.length) return;

    var allMains = section.querySelectorAll('.iconic-accordion-main');
    allMains.forEach(function(item) {
      var inner = item.querySelector('.iconic-content-inner');
      if (inner) {
        if (item.classList.contains('open') || item.classList.contains('active')) {
          inner.style.display = 'block';
          inner.style.height = 'auto';
          inner.style.maxHeight = 'none';
          inner.style.overflow = 'visible';
        } else {
          inner.style.display = 'none';
          inner.style.height = '0';
          inner.style.overflow = 'hidden';
        }
      }
    });

    triggers.forEach(function (trigger) {
      if (trigger.dataset.iconicAccordionFeatureBound) return;

      trigger.addEventListener('click', function () {
        var main = this.closest('.iconic-accordion-main');
        if (!main) return;

        var isOpen = main.classList.contains('open');
        allMains.forEach(function(item) {
          item.classList.remove('open', 'active');
          var btn = item.querySelector('.iconic-accordion-content');
          if (btn) btn.setAttribute('aria-expanded', 'false');
          
          var inner = item.querySelector('.iconic-content-inner');
          if (inner) {
            inner.style.display = 'none';
            inner.style.height = '0';
            inner.style.overflow = 'hidden';
          }
        });

        if (!isOpen) {
          main.classList.add('open', 'active');
          this.setAttribute('aria-expanded', 'true');
          
          var inner = main.querySelector('.iconic-content-inner');
          if (inner) {
            inner.style.display = 'block';
            inner.style.height = 'auto';
            inner.style.maxHeight = 'none';
            inner.style.overflow = 'visible';
          }
          
          var hasImage = main.getAttribute('data-has-image') === 'true';
          var blockIndex = main.getAttribute('data-block-index');
          var imgUrl = main.getAttribute('data-feature-image') || '';
          var imgSrcset = main.getAttribute('data-feature-srcset') || '';

          if (hasImage && imgUrl && previewImg) {
            previewImg.src = imgUrl;
            
            if (imgSrcset) {
              previewImg.srcset = imgSrcset;
              previewImg.sizes = "(min-width: 768px) 50vw, 100vw";
            } else {
              previewImg.removeAttribute('srcset');
              previewImg.removeAttribute('sizes');
            }

            var titleEl = this.querySelector('.iconic-advance-faq-fourth-title');
            previewImg.alt = titleEl ? titleEl.textContent.trim() : '';
            previewImg.classList.remove('iconic-d-none');

            placeholders.forEach(function (ph) {
              ph.classList.remove('iconic-advance-faq-fourth-placeholder-visible');
            });
          } else {
            if (previewImg) previewImg.classList.add('iconic-d-none');

            placeholders.forEach(function (ph) {
              if (ph.getAttribute('data-block-index') === blockIndex) {
                ph.classList.add('iconic-advance-faq-fourth-placeholder-visible');
              } else {
                ph.classList.remove('iconic-advance-faq-fourth-placeholder-visible');
              }
            });
          }
        }
      });
      trigger.dataset.iconicAccordionFeatureBound = 'true';
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('.iconic-advance-faq-fourth-section');
    sections.forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initSection(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iconic-advance-faq-third"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.addEventListener('click', function(e) {
      const summary = e.target.closest('details summary');
      if (!summary) return;
      const section = summary.closest('.iconic-advance-faq-third-section');
      if (!section) return;
      const details = summary.parentNode;
      if (!details.hasAttribute('open')) {
        const allDetails = section.querySelectorAll('details');
        allDetails.forEach(function(d) {
          if (d !== details) {
            d.removeAttribute('open');
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iconic-age-checker"] && !Shopify.designMode) return;
  try {
    
  window.isNumberKey = function(evt) {
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
    return false;
  return true;
  };
  
  setTimeout(() => {
    if (customElements.get("iconic-age-checker")) {
      return;
    }

    class IconicAgeCheckPopup extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.initIconicAgeCheckPopup();
        const birthMonthEl = document.querySelector("[id^='birthMonth-']");
        const birthDayEl = document.querySelector("[id^='birthDay-']");

        if (birthMonthEl && birthDayEl) {
          birthMonthEl.addEventListener(
            "keyup",
            this.removeErrorMessage.bind(this)
          );
          birthDayEl.addEventListener(
            "keyup",
            this.removeErrorMessage.bind(this)
          );
        }
      }

      removeErrorMessage(event) {
        var birthMonth = document.querySelector("[id^='birthMonth-']").value;
        var birthDay = document.querySelector("[id^='birthDay-']").value;

        if (event.key === "Backspace" || !isNaN(parseInt(event.key))) {
          if (
            birthMonth === "" ||
            birthDay === "" ||
            (parseInt(birthMonth) >= 1 && parseInt(birthMonth) <= 12)
          ) {
            document
              .querySelector(
                "iconic-age-checker .iconic-invalid-feedback.iconic-valid-month"
              )
              .classList.remove("iconic-d-block");
            document
              .querySelector(
                "iconic-age-checker .iconic-invalid-feedback.iconic-valid-day"
              )
              .classList.remove("iconic-d-block");
          }
        }
      }

      initIconicAgeCheckPopup() {
        const agecheckerPopup = document.querySelector("[id^='iconicAgecheckerPopup-']");
        const agecheckerModal = document.querySelector("[id^='iconicAgeModal-']");
        const testMode = agecheckerPopup.getAttribute("data-popup-test");
        const cookieName = agecheckerPopup.getAttribute("data-cokkie");
        let forms = document.querySelectorAll(".iconic-needs-validation");
        const yescheckButton = document.querySelector("[id^='iconicYesCheck-']");
        const nocheckButton = document.querySelector("[id^='iconicNoCheck-']");
        const countAgebtn = document.querySelectorAll("[id^='iconicAgeButton-']").length;
        const countYesbtn = document.querySelectorAll("[id^='iconicYesCheck-']").length;
        let ageCheckerFrequencyPopup = getCookie(cookieName);

        if (countYesbtn > 0) {
          nocheckButton.addEventListener("click", (event) => {
            event.preventDefault();
            document
              .querySelector("iconic-age-checker .iconic-invalid-feedback")
              .classList.add("iconic-d-block");
          });

          yescheckButton.addEventListener("click", () => {
            setCookie(cookieName, true);
            location.reload();
          });
        }

        if (countAgebtn > 0) {
          Array.prototype.slice.call(forms).forEach((form) => {
            const AgecheckButton = document.querySelector("[id^='iconicAgecheckform-']");
            AgecheckButton.addEventListener("submit", (event) => {
              if (!AgecheckButton.checkValidity()) {
                event.preventDefault();
                event.stopPropagation();
              }
              form.classList.add("was-validated");

              const currentDate = new Date();
              const birthDay = document.querySelector("[id^='birthDay-']").value;
              const birthMonth = document.querySelector("[id^='birthMonth-']").value;
              const birthYear = document.querySelector("[id^='birthYear-']").value;
              const dob = new Date(birthYear, birthMonth, birthDay);
              let age = currentDate.getFullYear() - dob.getFullYear();
              const agecheckerPopup = document.querySelector("[id^='iconicAgecheckerPopup-']");
              const ageLimit = parseInt(
                agecheckerPopup.getAttribute("data-age-number")
              );
              let isValidMonth =
                (parseInt(birthMonth) >= 1 && parseInt(birthMonth) <= 12) ||
                (birthMonth.length === 1 && parseInt(birthMonth) === 0);
              let isValidDay =
                (parseInt(birthDay) >= 1 && parseInt(birthDay) <= 31) ||
                (birthDay.length === 1 && parseInt(birthDay) > 0);

              if (birthMonth == "" || birthDay == "" || birthYear == "") {
                event.preventDefault();
                document
                .querySelector(
                  "iconic-age-checker .iconic-invalid-feedback.iconic-valid-date"
                )
                .classList.remove("iconic-d-block");
              }
              else if (!isValidDay && !isValidMonth) {
                event.preventDefault();
                document
                  .querySelector(
                    "iconic-age-checker .iconic-invalid-feedback.iconic-valid-day"
                  )
                  .classList.remove("iconic-d-block");
                document
                  .querySelector(
                    "iconic-age-checker .iconic-invalid-feedback.iconic-valid-month"
                  )
                  .classList.remove("iconic-d-block");
                document
                  .querySelector(
                    "iconic-age-checker .iconic-invalid-feedback.iconic-valid-date"
                  )
                  .classList.add("iconic-d-block");
              } 
              else if (!isValidDay) {
              event.preventDefault();
              document
                  .querySelector(
                    "iconic-age-checker .iconic-invalid-feedback.iconic-valid-date"
                  )
                  .classList.remove("iconic-d-block");
                document
                  .querySelector(
                    "iconic-age-checker .iconic-invalid-feedback.iconic-valid-day"
                  )
                  .classList.add("iconic-d-block");
            }
              else if (!isValidMonth) {
                event.preventDefault();
                document.querySelector("iconic-age-checker .iconic-invalid-feedback.iconic-valid-date").classList.remove("iconic-d-block");
                document.querySelector("iconic-age-checker .iconic-invalid-feedback.iconic-valid-month").classList.add("iconic-d-block");
              }
              else if (age < ageLimit) {
                event.preventDefault();
                document.querySelector("iconic-age-checker .iconic-invalid-feedback.iconic-age-error").classList.add("iconic-d-block");
                document.querySelector(".iconic-message-question").classList.add("iconic-d-none");
              }
              else {
                agecheckerModal.hide();
                document.body.style["pointer-events"] = "auto";
              }
            });
          }, false);
        }

        if (testMode) {
         setTimeout(function () {
          if (agecheckerModal) {
            agecheckerModal.show();
          }
         }, 100);
        } else {
          setTimeout(() => {
            if (!ageCheckerFrequencyPopup) {
              agecheckerModal.show();
            } else {
              agecheckerModal.hide();
            }
          }, 100);
        }
        agecheckerPopup.addEventListener("click", () => {
          setCookie(cookieName, true);
        });
      }
    }

    customElements.define("iconic-age-checker", IconicAgeCheckPopup);
  },1000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iconic-branding-text"] && !Shopify.designMode) return;
  try {
    
  function adjustFontSizeToFill(containerId, textId) {
    const container = document.getElementById(containerId);
    const text = document.getElementById(textId);
    if (!text) return;
  
    function adjustFontSize() {
      const targetPercentage = window.innerWidth <= 767
      ? parseFloat(text.getAttribute('data-font-size-mobile')) || 100
      : parseFloat(text.getAttribute('data-font-size')) || 100;
      
      let fontSize = 10;
      let increment = 1;
      let maxWidth = container.offsetWidth * (targetPercentage / 100);
      text.style.whiteSpace = 'nowrap';
      text.style.fontSize = `${fontSize}px`;
  
      while (text.offsetWidth < maxWidth && fontSize < 300) {
        fontSize += increment;
        text.style.fontSize = `${fontSize}px`;
      }
  
      if (text.offsetWidth > maxWidth) {
        fontSize -= increment;
        text.style.fontSize = `${fontSize}px`;
      }
      text.classList.add('adjusted');
    }
  
    setTimeout(() => {
      adjustFontSize();
    }, 250);
  
    window.addEventListener('resize', adjustFontSize);
  }
  
  function applyFontAdjustments() {
    const brandingSections = document.querySelectorAll('.iconic-branding-text-section');
    
    brandingSections.forEach((section) => {
      const sectionId = section.getAttribute('data-section-id');
      const containerId = `brandingWrapper-${sectionId}`;
      const textId = `brandingText-${sectionId}`;
      adjustFontSizeToFill(containerId, textId);
    });
  }
  window.addEventListener('load', applyFontAdjustments);
  document.addEventListener('DOMContentLoaded', applyFontAdjustments);
  
  document.addEventListener('shopify:section:load', function () {
    applyFontAdjustments();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iconic-image-comparison-first"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('iconic-image-comparison-first')) {
    class IconicImageComparisonFirst extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.initImageComparisonFirst();
      }
      initImageComparisonFirst() {
        const container = this.querySelector('.iconic-container-compare');

        this.querySelector('.iconic-slider-input').addEventListener('input', (e) => {
          container.style.setProperty('--position', `${e.target.value}%`);
        });
      }
    }
    customElements.define('iconic-image-comparison-first', IconicImageComparisonFirst);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iconic-image-comparison-fourth"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('iconic-image-comparison-fourth')) {
    class IconicImageComparisonFourth extends HTMLElement {
      connectedCallback() {
        this.initImageComparisonFourth();
      }
      initImageComparisonFourth() {
        const container = this.querySelector('.iconic-container-compare');
        const input = this.querySelector('.iconic-slider-input');
        if (container && input) {
          input.addEventListener('input', (e) => {
            container.style.setProperty('--position', `${e.target.value}%`);
          });
        }
      }
    }
    customElements.define('iconic-image-comparison-fourth', IconicImageComparisonFourth);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iconic-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  if (customElements.get('iconic-newsletter-popup')) {
    return;
  }

  class IconicnewsletterPopup extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initIconicnewsletterPopup();
    }

    initIconicnewsletterPopup() {
      const newsletterPopup = document.querySelector("[id^='iconicNewsletterPopup-']");
      const newsletterModal = document.querySelector("[id^='iconicNewsModal-']");
      const testMode = newsletterPopup.getAttribute('data-popup-test');
      const delay = newsletterPopup.getAttribute('data-popup-delay') * 1000;
      const frequency = newsletterPopup.getAttribute('data-popup-frequency');
      const cookieName = newsletterPopup.getAttribute('data-popup-name');
      const newsletterForm = this.querySelectorAll('.iconic-needs-validation');

      Array.from(newsletterForm).forEach(function (newsletterForm) {
        newsletterForm.addEventListener(
          'submit',
          function (event) {
            if (!newsletterForm.checkValidity()) {
              event.preventDefault();
              event.stopPropagation();
            } else {
              setCookie(cookieName, true, frequency);
              newsletterModal.hide();
            }
            newsletterForm.classList.add('was-validated');
          },
          false
        );
      });

      if (testMode) {
        setTimeout(function () {
          newsletterModal.show();
        }, delay);
      } else {
        setTimeout(function () {
          const days = getCookie(cookieName);
          if (!days) {
            newsletterModal.show();
          }
        }, delay);
      }

      const closeButton = this.querySelector('.iconic-btn-close');
      closeButton.addEventListener('click', () => {
        setCookie(cookieName, true, frequency);
        newsletterModal.hide();
      });
    }
  }
  customElements.define('iconic-newsletter-popup', IconicnewsletterPopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  const input = document.querySelector('[data-blog-filter-input]');
  const clearBtn = document.querySelector('[data-blog-filter-clear]');
  const noResults = document.querySelector('[data-blog-no-results]');
  const articles = document.querySelectorAll('.blog-post-item');
  const pagination = document.querySelector('.pagination');

  if (input && articles.length) {
    input.addEventListener('input', () => {
      const query = input.value.trim().toLowerCase();

      clearBtn.hidden = !query;

      if (!query) {
        articles.forEach(a => a.hidden = false);
        if (noResults) noResults.hidden = true;
        if (pagination) pagination.style.display = '';
        return;
      }

      if (pagination) pagination.style.display = 'none';

      let matchCount = 0;

      articles.forEach(article => {
        const title = (article.querySelector('.blog-post-card__title')?.textContent || '').toLowerCase();
        const excerpt = (article.querySelector('.blog-post-card__content-text')?.textContent || '').toLowerCase();
        const matches = title.includes(query) || excerpt.includes(query);
        article.hidden = !matches;
        if (matches) matchCount++;
      });

      if (noResults) noResults.hidden = matchCount > 0;
    });

    clearBtn?.addEventListener('click', () => {
      input.value = '';
      input.dispatchEvent(new Event('input'));
      input.focus();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
